import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { CartResponse } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { GiftCardBalanceInquiryDto } from 'src/tendering/interfaces/gift-card-balance-inquiry-dto';

export const giftCardBalanceInquiry = async (
  giftCardBalanceInquiryDto: GiftCardBalanceInquiryDto,
): Promise<CartResponse> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/tenders/balance-inquiry`,
    method: 'POST',
    data: giftCardBalanceInquiryDto,
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  return emeraldRequest<CartResponse>(emeraldRequestParams);
};
